import styled, { css } from "styled-components";
import { ReactSVG } from "react-svg";

export const GoBackButtonWrapper = styled.div`
  padding: 20px 0;
`;

// export const GoTopoButtonWrapper = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   padding: 20px 0;
// `;

export const Wrapper = styled.div`
  margin: 10rem 5rem 0 35rem;

  @media (min-width: 1600px) {
    margin: 8rem 5rem 0 35rem;
  }

  /* posição navegação */
  @media only screen and (max-width: 480px) {
    margin: 0 1rem 0 1rem;
  }
  @media only screen and (max-width: 978px) {
    margin: 0 1rem 0 1rem;
  }
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-weight: 500;
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.medium};
    line-height: 1.2;

    @media only screen and (max-width: 500px) {
      font-size: 1.2rem;
    }
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    border-bottom: 0.3rem solid ${theme.colors.lineBlue};

    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media only screen and (max-width: 998px) {
      margin-top: 8rem;
    }
  `}
`;

export const Tabs = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin: 4rem 0 5rem 0;
    color: ${theme.colors.gray};
    font-family: Roboto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    overflow: auto;

    div:first-child {
      border: none;
    }
  `}
`;

export const TabIcon = styled(ReactSVG)`
  size: 24px;
`;

export const SeparatorWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    border-left: 1px solid ${theme.colors.gray};
    padding: 0 10px;
  `}
`;

export const HeaderItem = styled.div`
  ${({ theme }) => css`
    cursor: pointer;
    font-size: ${theme.font.sizes.large};
    font-weight: 500;
    text-align: center;
    height: 5rem;
  `}

  p {
    color: ${({ active }) => (active ? "#00a2e0" : "auto")};
    margin-top: 3px;
  }
  svg {
    fill: ${({ active }) => (active ? "#012d5c" : "auto")};
  }
`;

export const BoxUser = styled.div`
  ${({ theme }) => css`
    width: 80%;
    display: flex;
    align-items: center;
    padding-bottom: 0.8rem;

    ${Description} {
      color: ${theme.colors.gray};
      font-style: normal;
    }

    @media (min-width: 1600px) {
      margin-top: 1.8rem;
      ${Description} {
        font-size: ${theme.font.sizes.medium};
      }
    }
  `}
`;

export const Image = styled.img`
  margin-right: 1.5rem;
  height: 4rem;

  @media (min-width: 1600px) {
    height: 5rem;
  }

  @media only screen and (max-width: 500px) {
    height: 2.8rem;
  }
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-family: "Roboto";
    font-size: ${theme.font.sizes.large};
    color: ${theme.colors.grayFour};
    font-weight: bold;

    @media (min-width: 1600px) {
      font-size: ${theme.font.sizes.large};
    }
    @media only screen and (max-width: 500px) {
      font-size: 1.4rem;
    }
  `}
`;
